module.exports = __webpack_public_path__ + "media/icons/heart-ad1fb195.svg";